import { createContext, use, type ReactNode } from 'react';

const IntersectionTrackingContext = createContext(false);

export const IntersectionTrackingProvider = ({
  children,
  parentTracksIntersection,
}: {
  children: ReactNode;
  parentTracksIntersection: boolean;
}) => (
  <IntersectionTrackingContext.Provider value={parentTracksIntersection}>
    {children}
  </IntersectionTrackingContext.Provider>
);

export const useSkipIntersectionTracking = () => use(IntersectionTrackingContext);
